import React, { useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo1.png";

const Footer = ({
  mainRef,
  aboutRef,
  servicesRef,
  featuresRef,
  pricingRef,
  contactRef,
}) => {
  const ref = useRef(null);

  const handleScroll = (ref) => {
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: "smooth",
    });
    const div = document.querySelector("#navbar");
  };

  return (
    <div>
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 footer-info" id="logo">
                {/* <h1 className="text-white">
                  CONF<span>CHAIR</span>
                </h1> */}
                <img src={logo} alt="Conf Chair" />
                <p className="text-justify">
                  Welcome to ConfChair! We're redefining conference management
                  for a seamless experience. Our user-friendly platform handles
                  everything from submissions to virtual engagement. With
                  features like the Interactive Agenda Builder and Live
                  Streaming, we empower organizers and attendees alike. Opt for
                  excellence with ConfChair, where your success is our mission.
                  Join us and explore the future of conferences effortlessly!
                </p>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(mainRef.current);
                      }}
                    >
                      Home
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(aboutRef.current);
                      }}
                    >
                      About
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(servicesRef.current);
                      }}
                    >
                      Services
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(featuresRef.current);
                      }}
                    >
                      Features
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(pricingRef.current);
                      }}
                    >
                      Pricing
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(mainRef.current);
                      }}
                    >
                      Home
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(aboutRef.current);
                      }}
                    >
                      About
                    </Link>
                  </li>
                  <li className="d-flex flex-row">
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link
                      className="nav-link link-button scrollto"
                      onClick={() => {
                        handleScroll(servicesRef.current);
                      }}
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="/terms-of-service">Terms of service</a>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <a href="#">Privacy policy</a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-3 col-md-6 footer-contact">
                <h4>Contact Us</h4>
                <p>
                  <strong>Phone:</strong>{" "}
                  <a href="tel:+917409882374">+91 7409882374</a>
                  <br />
                  <strong>Email:</strong>{" "}
                  <a href="mailto:info.confchair@gmail.com">
                    info.confchair@gmail.com
                  </a>
                  <br />
                </p>

                <div className="social-links">
                  <a href="#" className="twitter">
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a href="#" className="facebook">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="#" className="instagram">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="#" className="google-plus">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="#" className="linkedin">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="copyright">
            &copy; Copyright <strong>Conf Chair</strong>. All Rights Reserved
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
